// routes:
export const ROOT_LOCATION_PATH = '/';
export const CATEGORY_LOCATION_PATH = `${ROOT_LOCATION_PATH}:categoryId`;
export const CATEGORY_ITEMS_LOCATION_PATH = `${CATEGORY_LOCATION_PATH}/:title`;
export const CATEGORY_SUBMISSIONS_LOCATION_PATH = `${CATEGORY_LOCATION_PATH}/leads`;
export const CATEGORY_PEOPLE_LOCATION = `${CATEGORY_LOCATION_PATH}/people`;
export const SETTINGS_LOCATION_PATH = '/settings';

// actions:
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';

export const CHECK_SECURITY_START = 'CHECK_SECURITY_START';
export const CHECK_SECURITY_SUCCESS = 'CHECK_SECURITY_SUCCESS';
export const CHECK_SECURITY_FAIL = 'CHECK_SECURITY_FAIL';

export const PHONE_AUTH_START = 'PHONE_AUTH_START';
export const PHONE_AUTH_SUCCESS = 'PHONE_AUTH_SUCCESS';
export const PHONE_AUTH_FAIL = 'PHONE_AUTH_FAIL';

export const LOG_IN_START = 'LOG_IN_START';
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
export const LOG_IN_FAIL = 'LOG_IN_FAIL';

export const INIT_START = '=== INIT_START ===';
export const INIT_SUCCESS = '=== INIT_SUCCESS ===';
export const INIT_FAIL = '=== INIT_FAIL ===';

export const SET_BUSY = 'SET_BUSY';

export const GET_ITEMS_START = 'GET_ITEMS_START';
export const GET_ITEMS_SUCCESS = 'GET_ITEMS_SUCCESS';
export const GET_ITEMS_FAIL = 'GET_ITEMS_FAIL';
export const UPDATE_ITEM_START = 'UPDATE_ITEM_START';
export const UPDATE_ITEM_SUCCESS = 'UPDATE_ITEM_SUCCESS';
export const UPDATE_ITEM_FAIL = 'UPDATE_ITEM_FAIL';
export const DELETE_ITEM_START = 'DELETE_ITEM_START';
export const DELETE_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS';
export const DELETE_ITEM_FAIL = 'DELETE_ITEM_FAIL';

export const GET_PEOPLE_ITEMS_START = 'GET_PEOPLE_ITEMS_START';
export const GET_PEOPLE_ITEMS_SUCCESS = 'GET_PEOPLE_ITEMS_SUCCESS';
export const GET_PEOPLE_ITEMS_FAIL = 'GET_PEOPLE_ITEMS_FAIL';
export const UPDATE_PEOPLE_ITEM_START = 'UPDATE_PEOPLE_ITEM_START';
export const UPDATE_PEOPLE_ITEM_SUCCESS = 'UPDATE_PEOPLE_ITEM_SUCCESS';
export const UPDATE_PEOPLE_ITEM_FAIL = 'UPDATE_PEOPLE_ITEM_FAIL';
export const DELETE_PEOPLE_ITEM_START = 'DELETE_PEOPLE_ITEM_START';
export const DELETE_PEOPLE_ITEM_SUCCESS = 'DELETE_PEOPLE_ITEM_SUCCESS';
export const DELETE_PEOPLE_ITEM_FAIL = 'DELETE_PEOPLE_ITEM_FAIL';

export const GET_CATEGORIES_START = 'GET_CATEGORIES_START';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAIL = 'GET_CATEGORIES_FAIL';

export const CREATE_CATEGORIES_START = 'CREATE_CATEGORIES_START';
export const CREATE_CATEGORIES_FAIL = 'CREATE_CATEGORIES_FAIL';
export const CREATE_CATEGORIES_SUCCESS = 'CREATE_CATEGORIES_SUCCESS';

export const DELETE_CATEGORY_START = 'DELETE_CATEGORY_START';
export const DELETE_CATEGORY_FAIL = 'DELETE_CATEGORY_FAIL';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';

export const UPDATE_CATEGORY_START = 'UPDATE_CATEGORY_START';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAIL = 'UPDATE_CATEGORY_FAIL';

export const GET_SUBMISSIONS_START = 'GET_SUBMISSIONS_START';
export const GET_SUBMISSIONS_SUCCESS = 'GET_SUBMISSIONS_SUCCESS';
export const GET_SUBMISSIONS_FAIL = 'GET_SUBMISSIONS_FAIL';

export const GET_ALL_SUBMISSIONS_START = 'GET_ALL_SUBMISSIONS_START';
export const GET_ALL_SUBMISSIONS_SUCCESS = 'GET_ALL_SUBMISSIONS_SUCCESS';
export const GET_ALL_SUBMISSIONS_FAIL = 'GET_ALL_SUBMISSIONS_FAIL';

export const LOG_OUT = 'LOG_OUT';
export const LOG_OUT_FAIL = 'LOG_OUT_FAIL';

// settings actions:
export const GET_SETTINGS_START = 'GET_SETTINGS_START';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';
export const GET_SETTINGS_FAIL = 'GET_SETTINGS_FAIL';

export const UPDATE_SETTINGS_START = 'UPDATE_SETTINGS_START';
export const UPDATE_SETTINGS_SUCCESS = 'UPDATE_SETTINGS_SUCCESS';
export const UPDATE_SETTINGS_FAIL = 'UPDATE_SETTINGS_FAIL';

// company actions:
export const GET_COMPANIES_START = 'GET_COMPANIES_START';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_FAIL = 'GET_COMPANIES_FAIL';

export const UPDATE_COMPANY_START = 'UPDATE_COMPANY_START';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_FAIL = 'UPDATE_COMPANY_FAIL';

export const UPDATE_COMPANIES_ORDER_START = 'UPDATE_COMPANIES_ORDER_START';
export const UPDATE_COMPANIES_ORDER_SUCCESS = 'UPDATE_COMPANIES_ORDER_SUCCESS';
export const UPDATE_COMPANIES_ORDER_FAIL = 'UPDATE_COMPANIES_ORDER_FAIL';

export const DELETE_COMPANY_START = 'DELETE_COMPANY_START';
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY_SUCCESS';
export const DELETE_COMPANY_FAIL = 'DELETE_COMPANY_FAIL';

// job actions:
export const UPDATE_JOB_START = 'UPDATE_JOB_START';
export const UPDATE_JOB_SUCCESS = 'UPDATE_JOB_SUCCESS';
export const UPDATE_JOB_FAIL = 'UPDATE_JOB_FAIL';

export const UPDATE_JOBS_ORDER_START = 'UPDATE_JOBS_ORDER_START';
export const UPDATE_JOBS_ORDER_SUCCESS = 'UPDATE_JOBS_ORDER_SUCCESS';
export const UPDATE_JOBS_ORDER_FAIL = 'UPDATE_JOBS_ORDER_FAIL';

export const DELETE_JOB_START = 'DELETE_JOB_START';
export const DELETE_JOB_SUCCESS = 'DELETE_JOB_SUCCESS';
export const DELETE_JOB_FAIL = 'DELETE_JOB_FAIL';

// item actions:
export const GET_ITEMS = 'GET_ITEMS';
export const ADD_ITEM = 'ADD_ITEM';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const UPDATE_ITEMS_ORDER = 'UPDATE_ITEMS_ORDER';
export const APPLY_ITEMS_ORDER = 'APPLY_ITEMS_ORDER';
export const REMOVE_ITEM = 'REMOVE_ITEM';

// scores:
export const GET_CATEGRY_SCORES_START = 'GET_CATEGRY_SCORES_START';
export const GET_CATEGRY_SCORES_SUCCESS = 'GET_CATEGRY_SCORES_SUCCESS';
export const GET_CATEGRY_SCORES_FAIL = 'GET_CATEGRY_SCORES_FAIL';

// media actions:
export const UPLOAD_MEDIA = 'UPLOAD_MEDIA';
export const DELETE_MEDIA = 'DELETE_MEDIA';

export const SET_POP_UP = 'SET_POP_UP';

// popups:
export const INFO_POP_UP = 'INFO_POP_UP';
export const CONFIRMATION_POP_UP = 'CONFIRMATION_POP_UP';

// editors:
export const EDIT_MODE = 'EDIT_MODE';
export const CREATE_MODE = 'CREATE_MODE';

// forms:
export const PHONE_AUTH_FORM_DEFAULTS = {
	phone: '',
};

export const PHONE_AUTH_CONFIRM_FORM_DEFAULTS = {
	code: '',
};

export const ITEM_EDITOR_FORM_DEFAULT = {
	id: '',
	categoryId: '',
	title: '',
	subtitle: '',
	file: {
		remoteURL: '',
		file: { name: '', url: '' },
		selected: 'remoteURL', // 'remoteURL' or 'file'
	},
};
// export const IMG_ITEM_EDITOR_FORM_DEFAULT = {
// 	id: '',
// 	categoryId: '',
// 	songName: '',
// 	file: {
// 		remoteURL: '',
// 		file: { name: '', url: '' },
// 		selected: 'remoteURL', // 'remoteURL' or 'file'
// 	},
// };

// errors:
export const ACCESS_DENIED_ERROR = 'ACCESS_DENIED_ERROR';

export const JOB_EDITOR_FORM_DEFAULT = {
	_id: '',
	title: '',
	desc: '',
	details: '',
	size: '',
	startDate: '',
	place: '',
	requirements: '',
	email: '',
	order: 0,
};

// All voted users size:
export const GET_ALL_VOTED_USERS_SIZE_START = 'GET_ALL_VOTED_USERS_SIZE_START';
export const GET_ALL_VOTED_USERS_SIZE_SUCCESS = 'GET_ALL_VOTED_USERS_SIZE_SUCCESS';
export const GET_ALL_VOTED_USERS_SIZE_FAIL = 'GET_ALL_VOTED_USERS_SIZE_FAIL';
